import { ISection } from '../../../interfaces/scheduler_interfaces';
import { RegistrationWaitlistPositionModel } from '../models/registration_waitlist_position_model';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IHash, IQuery, IQueryMediator } from 'core-ts-types';

import { IRegistrationSection } from '../../../interfaces/scheduler_interfaces';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { RegisterSectionFilters } from '../filters/register_sections_filters';
import { RequisiteCourseServant } from '../servants/requisite_course_servant';
import * as _4 from 'lodash4';
import { ScheduledSectionStatusServant } from '../servants/scheduled_section_status_servant';
export class RegisterSectionsQuery implements IQuery {
  private _result: {
    scheduledSections: ISection[];
    selectedSections: ISection[];
    unselectedSections: ISection[];
    coReqMissingSections: ISection[];
    preReqMissingSections: ISection[];
    waitlistedSections: ISection[];
  };

  constructor(
    QueryMediator: IQueryMediator,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngRegisterSectionFilters: RegisterSectionFilters,
    private ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
    private ngRequisiteCourseServant: RequisiteCourseServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngRegistrationWaitlistPositionModel: RegistrationWaitlistPositionModel,
    private registrationRTRSvc: any
  ) {
    QueryMediator.registerQuery(
      this,
      ngSectionsDatasource,
      ngRegisterSectionsDatasource,
      ngRegistrationWaitlistPositionModel
    );
  }

  run() {
    const scheduledSections: ISection[] = this.ngRegisterSectionFilters.getScheduledSelectableSections(
      this.ngRegisterSectionsDatasource.values().filter((section: ISection) => section._course)
    );

    const selectedSections = _4.filter(
      scheduledSections,
      (section: IRegistrationSection) => section.is_selected && section._isEligibleForRegistration
    );
    const unselectedSections = _4.filter(
      scheduledSections,
      (section: IRegistrationSection) => !section.is_selected || !section._isEligibleForRegistration
    );
    const coReqMissingSections = _4.filter(selectedSections, (section: IRegistrationSection) =>
      this.ngRequisiteCourseServant.isCoReqMissing(section)
    );
    const preReqMissingSections = _4.filter(selectedSections, (section: IRegistrationSection) =>
      this.ngRequisiteCourseServant.isPreReqMissing(section)
    );
    const waitlistedSections = _4.filter(this.ngRegisterSectionsDatasource.values(), (section: IRegistrationSection) =>
      this.ngScheduledSectionStatusServant.isStatusWaitlisted(section)
    );

    this._result = {
      scheduledSections,
      selectedSections,
      unselectedSections,
      coReqMissingSections,
      preReqMissingSections,
      waitlistedSections
    };
    this.registrationRTRSvc.updateCRNs(scheduledSections);
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngRegisterSectionsQuery', RegisterSectionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/queries/register_sections_query.ts